import labels from './panelLabels.json';

// The wording a farmer reads on the panel and the wording a support employee
// reads here have to be the same, or a phone call goes sideways. The panel
// never hardcodes a field name: it turns the field key into words and looks
// the result up in its own translation table. panelLabels.json is a straight
// copy of that table, so keeping the two in step is a single file copy after
// the panel's wording changes.
//
// Some keys have no entry, mostly the AI and AO slopes and offsets. The panel
// falls back to the bare key there, so it shows "Ai apt temp offset"; we pass
// the wording this site already had instead, which reads better and loses
// nothing, since there is no panel wording to disagree with.
export const panelLabel = (name, fallback) => {
  if (!name) return fallback || '';
  const key = name.split('_').join(' ');
  const text = labels[key];
  if (!text) return fallback || key.charAt(0).toUpperCase() + key.slice(1);
  return text.charAt(0).toUpperCase() + text.slice(1);
};

export default panelLabel;
